export default __webpack_public_path__ + "static/media/005-boxing ring.2cf00cba.svg";